/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_Passkey_DeletedInputs */



/**
* | output |
* | --- |
* | "Passkey deleted successfully!" |
*
* @param {Profile_Security_Passkey_DeletedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_passkey_deleted = /** @type {((inputs?: Profile_Security_Passkey_DeletedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Passkey_DeletedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Passkey erfolgreich gelöscht!")
	return /** @type {LocalizedString} */ ("Passkey deleted successfully!")
});